import { message } from 'antd';

function isLocalDevOrigin(origin) {
  return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(origin || '');
}

export function isAllowedMcpOAuthMessageOrigin(origin) {
  if (origin === window.location.origin) return true;
  return isLocalDevOrigin(origin) && isLocalDevOrigin(window.location.origin);
}

export function openMcpOAuthPopup(authorizationUrl, { serverId, onClosedWithoutSuccess } = {}) {
  const popup = window.open(authorizationUrl, 'mcp_oauth', 'width=520,height=720');
  if (!popup) {
    message.error('Popup blocked — allow popups for this site and try Sign in again');
    return popup;
  }
  message.info('Complete sign-in in the popup window');
  const timer = window.setInterval(() => {
    if (!popup.closed) return;
    window.clearInterval(timer);
    onClosedWithoutSuccess?.(serverId);
  }, 500);
  return popup;
}

export function parseMcpOAuthPostMessage(event) {
  if (!isAllowedMcpOAuthMessageOrigin(event.origin)) return null;
  if (event.data?.type !== 'focusml_mcp_oauth') return null;
  return event.data;
}

/** Subscribe to OAuth completion postMessage; returns unsubscribe fn. */
export function subscribeMcpOAuthPostMessage(handler) {
  const onMessage = (event) => {
    const data = parseMcpOAuthPostMessage(event);
    if (data) handler(data);
  };
  window.addEventListener('message', onMessage);
  return () => window.removeEventListener('message', onMessage);
}

export function handleMcpOAuthResult(data, { onSuccess, onError } = {}) {
  if (data.status === 'ok') {
    message.success('MCP OAuth connected');
    onSuccess?.(data);
    return;
  }
  message.error(data.message || 'MCP OAuth failed');
  onError?.(data);
}
